export function OutlineShareIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9972 7.03201C14.1027 7.03201 14.9988 6.12941 14.9988 5.01601C14.9988 3.9026 14.1027 3 12.9972 3C11.8918 3 10.9956 3.9026 10.9956 5.01601C10.9956 6.12941 11.8918 7.03201 12.9972 7.03201Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.47559 17.0016C6.84349 17.0016 7.95239 15.882 7.95239 14.5008C7.95239 13.1196 6.84349 12 5.47559 12C4.10768 12 2.99878 13.1196 2.99878 14.5008C2.99878 15.882 4.10768 17.0016 5.47559 17.0016Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9988 20.9992C19.6556 20.9992 20.9988 19.6453 20.9988 17.9752C20.9988 16.3051 19.6556 14.9512 17.9988 14.9512C16.3419 14.9512 14.9988 16.3051 14.9988 17.9752C14.9988 19.6453 16.3419 20.9992 17.9988 20.9992Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7442 6.58008L7.00659 12.5321"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.109 17.1652L7.88501 15.082"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
